import { FiltersBarModel } from '@_types/molecules';

const researchSearchFiltersBarData: FiltersBarModel = {
  searchId: 'research-search',
  itemType: 'insights',
  excludeJs: true,
};

export { researchSearchFiltersBarData };
